import { NgModule } from '@angular/core';
import { featureReducer } from '@k2/common/entities-state/reducers';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [StoreModule.forFeature('entities', featureReducer)],
  providers: []
})
export class EntitiesStateModule {}
